import styled from 'styled-components';

const IWGGameMainWrapperBackgroundColor = ({theme:{$iwgGameMainWrapper}}) => `${$iwgGameMainWrapper}`; 
const IWGGameNameColor = ({theme:{$iwgGameNameColor}}) => `${$iwgGameNameColor}`;

const S = {}

S.InstantWinGameWrapper = styled.div`
    padding: 15px;
    background-color: ${IWGGameMainWrapperBackgroundColor};
`

S.GameNameRow = styled.div`
    position: relative;
    margin-top: 15px;
    margin-bottom: 15px;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    color: ${IWGGameNameColor};
`

S.BackBtn = styled.div`
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    color: ${IWGGameNameColor};
    padding: 0.5rem;
    border: 1px solid ${IWGGameNameColor};;
    border-radius: 0.5rem;
    position: absolute;
    left: 0;
    width: 15%;
`

S.GameName = styled.div`
    padding: 0.5rem;
`

S.PlayerWrapper = styled.div`
    position:relative;
    height: 0;
    width: 100%;
    padding-bottom: 150%;

    & .player {
        position: absolute;
        top: 0;
        left: 0;
        border: none;
        width: 100%;
        height: 100%;
    }
`


export default S